// const isProduction = process.env.NODE_ENV === 'production';
const apiServer = 'https://dbbackendapi.caeruscommodities.com/api';

const config = {
    basename: '',
    defaultPath: '/overview',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    theme: 'light', // light, dark
    presetColor: 'theme1',
    apiServer
};

export default config;
